// THE SHELL A CONTENT WRITER SEES — and it is not the staff one with the menu removed.
//
// ⚠ WHY A SEPARATE SHELL RATHER THAN A FILTERED SIDEBAR. Filtering the nav was the first
// fix, and on its own it left a writer with an EMPTY sidebar beside a landing page that
// answered 403 to everything it asked — which reads just as broken as the wall of dead
// links it replaced. The staff shell cannot serve a writer, because it is built on two
// providers that fetch before any route renders:
//
//   LookupsProvider  → GET /settings   403 for a writer
//   AlertsProvider   → GET /alerts     403 for a writer
//
// Both are correct refusals from the server's mount table. But a shell whose first two
// requests are forbidden has nothing to draw, so a writer gets this instead: no sidebar,
// no bell, no lookups, no alerts. One screen, which is what the role means.
//
// ⚠ THIS ENFORCES NOTHING. It is the same courtesy the nav filtering is: every endpoint
// a writer could reach for is classified on the server, and a writer typing any URL gets
// a refusal from the API regardless of what this renders. The shell decides what is worth
// drawing; the server decides what may be read.
//
// The upload screen (pages/Uploads) is its children — the one screen this role has.
import he from '../i18n/he';
import { useAuth } from '../context/AuthContext';
import Button from './Button';
import Logo from './Logo';
import ThemeSwitch from './ThemeSwitch';

export default function LimitedShell({ children }) {
  const { partner: user, logout } = useAuth();

  return (
    <div className="app limited">
      <div className="main">
        {/* The same top bar the staff shell has, minus the bell — a writer has no
            notifications, because nothing in the system can come due for them. */}
        <div className="topbar">
          <Logo className="topbar-logo" />
          <div className="row">
            <ThemeSwitch />
            <span className="who-avatar" aria-hidden>{String(user.name || '').trim().charAt(0)}</span>
            <span className="who">{user.name}</span>
            <Button variant="subtle" small onClick={logout}>
              {he.nav.logout}
            </Button>
          </div>
        </div>
        <div className="content">{children}</div>
      </div>
    </div>
  );
}

